import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import DataProtectionSoftwareService from "src/modules/data-protection/apis/DataProtectionSoftwareService";

export const SOFTWARE_OVERVIEW_QUERY_KEY =
    "gdpr-software-compliance-overview";

const useSoftwareOverview = ({ softwareId, t }) => {
    return useQuery({
        queryKey: [SOFTWARE_OVERVIEW_QUERY_KEY, softwareId],
        queryFn: async () => {
            const service = DataProtectionSoftwareService.getInstance();

            return await service.fetchComplianceOverview(softwareId);
        },
        enabled: Boolean(softwareId),
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toast(
                t("An error occurred while fetching overview content."),
                {
                    type: "error"
                }
            );
        }
    });
};

export default useSoftwareOverview;
